import mitt from 'mitt'

export enum Events {
  SHOW_SUCCESS = 'toast-success',
  SHOW_INFO = 'toast-info',
  SHOW_ERROR = 'toast-error',
  SHOW_SYSTEM_ERROR = 'system-error',
  DEFAULT_ERROR = 'default-error',
}

export enum DialogEvent {
  SHOW_DIALOG = 'show-dialog',
  SHOW_CONFIRM = 'show-confirm',
  SHOW_ERROR = 'show-error',
  DONE = 'done',
  FORCE_QUITE = 'force-quite',
}

export interface ModalContent {
  title: string
  text: string
  confirm?: string
  cancel?: string
  level?: string
  reload?: boolean
  riddle?: string
  riddle_text?: string
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
let eventBus: ReturnType<typeof mitt<any>> | null = null
// eslint-disable-next-line @typescript-eslint/no-explicit-any
let dialogBus: ReturnType<typeof mitt<any>> | null = null

export const useEventBus = () => {
  if (eventBus === null) {
    eventBus = mitt()
  }
  return eventBus
}

export const useDialogBus = () => {
  if (dialogBus === null) {
    dialogBus = mitt()
  }
  return dialogBus
}
